import * as actionTypes from './actionTypes';
import { combineReducers, defaultTtmFilter } from '@/finsight/application/League/helpers';

const periodsReducerInitialState = {
  isCollectionFetching: false,
  collection: [defaultTtmFilter],
  selected: defaultTtmFilter,
};

const getPeriodsReducer = (actionTypesConfig) => (state = periodsReducerInitialState, action) => {
  switch (action.type) {
    case actionTypesConfig.GET_PERIODS:
      return {
        ...state,
        isCollectionFetching: true,
      };
    case actionTypesConfig.GET_PERIODS_SUCCESS:
      return {
        ...state,
        isCollectionFetching: false,
        collection: action.payload,
      };
    case actionTypesConfig.GET_PERIODS_ERROR:
      return {
        ...state,
        isCollectionFetching: false,
      };
    case actionTypesConfig.SET_SELECTED_PERIOD:
      return {
        ...state,
        selected: action.payload,
      };
    case actionTypesConfig.RESET_PERIODS:
      return periodsReducerInitialState;
    default:
      return state;
  }
};

export default combineReducers({
  leagueTable: getPeriodsReducer({
    GET_PERIODS: actionTypes.GET_LEAGUE_TABLE_PERIODS,
    GET_PERIODS_SUCCESS: actionTypes.GET_LEAGUE_TABLE_PERIODS_SUCCESS,
    GET_PERIODS_ERROR: actionTypes.GET_LEAGUE_TABLE_PERIODS_ERROR,
    SET_SELECTED_PERIOD: actionTypes.SET_LEAGUE_TABLE_PERIOD,
    RESET_PERIODS: actionTypes.RESET_LEAGUE_TABLE_PERIODS,
  }),
  topUnderwriters: getPeriodsReducer({
    GET_PERIODS: actionTypes.GET_LEAGUE_TABLE_TOP_UNDERWRITERS_PERIODS,
    GET_PERIODS_SUCCESS: actionTypes.GET_LEAGUE_TABLE_TOP_UNDERWRITERS_PERIODS_SUCCESS,
    GET_PERIODS_ERROR: actionTypes.GET_LEAGUE_TABLE_TOP_UNDERWRITERS_PERIODS_ERROR,
    SET_SELECTED_PERIOD: actionTypes.SET_LEAGUE_TABLE_TOP_UNDERWRITERS_PERIOD,
    RESET_PERIODS: actionTypes.RESET_LEAGUE_TABLE_TOP_UNDERWRITERS_PERIODS,
  }),
  topRatingAgencies: getPeriodsReducer({
    GET_PERIODS: actionTypes.GET_LEAGUE_TABLE_TOP_RATING_AGENCIES_PERIODS,
    GET_PERIODS_SUCCESS: actionTypes.GET_LEAGUE_TABLE_TOP_RATING_AGENCIES_PERIODS_SUCCESS,
    GET_PERIODS_ERROR: actionTypes.GET_LEAGUE_TABLE_TOP_RATING_AGENCIES_PERIODS_ERROR,
    SET_SELECTED_PERIOD: actionTypes.SET_LEAGUE_TABLE_TOP_RATING_AGENCIES_PERIOD,
    RESET_PERIODS: actionTypes.RESET_LEAGUE_TABLE_TOP_RATING_AGENCIES_PERIODS,
  }),
});
